import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const JsonParseFatalError = BaseErrorSchema.extend({
  errorType: z.literal('JsonParseFatalError'),
  errorReason: z.string(),
});

export type JsonParseFatalError = z.infer<typeof JsonParseFatalError>;
